// extracted by mini-css-extract-plugin
export default {"btn":"ui_btn__galbo","inp":"ui_inp__QrUbA","inpArea":"ui_inpArea__GO4wT","heading":"ui_heading__N7-Gw","logo":"ui_logo__ktMjU","linker":"ui_linker__KFmhd"};